"use strict";

import "./ProgressBar.css";
import React from "react";
import Spinner from "./../Spinner";
import classnames from "classnames";

export default class ProgressBar extends React.Component {
	
	renderIndeterminate() {
		return (
			<div className={classnames("ProgressBar Indeterminate", {"Hidden": !this.props.shown})}>
				<label>{this.props.label}</label>
				<div>
					<Spinner/>
				</div>
			</div>
		);
	}
	
	renderDeterminate() {
		
		let progress = this.props.progress > 100 ? 100 : (this.props.progress < 0 ? 0 : this.props.progress);
		
		return (
			<div className={classnames("ProgressBar Determinate", {"Hidden": !this.props.shown})}>
				<div>
					<label>{this.props.label}</label>
					<span className={!this.props.showProgress ? "Hidden" : ""} style={{fontSize: this.props.fontSize+"px"}}>{progress} %</span>
				</div>
				<div>
					<div style={{
						height: this.props.height + "px",
						backgroundColor: this.props.color,
						width: progress + "%"
					}}></div>
				</div>
			</div>
		);
	}
	
	render() {
		if (this.props.indeterminate)
			return this.renderIndeterminate();
		else
			return this.renderDeterminate();
	}
	
}

ProgressBar.propTypes = {
	indeterminate: React.PropTypes.bool,
	label: React.PropTypes.string,
	color: React.PropTypes.string,
	height: React.PropTypes.number,
	fontSize: React.PropTypes.number,
	showProgress: React.PropTypes.bool,
	progress: React.PropTypes.number,
	shown: React.PropTypes.bool
};

ProgressBar.defaultProps = {
	indeterminate: false,
	label: "",
	color: "#444",
	height: 5,
	fontSize: 16,
	showProgress: true,
	progress: 0,
	shown: true
};


// WEBPACK FOOTER //
// ./~/vwa/components/ProgressBar/ProgressBar.jsx